/* PagingOsPlanResultsFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");

class PagingOsPlanResultsFeed extends PagingFeed {
    _getFeed() {
        if (this._EntityDef.type === "OsUpgradePlan") {
            return this._EntityDef.startRelatedExecutionFeed({});
        } else {
            return this._EntityDef.startRelatedResultsFeed({}, this._entityFields, this._sort, {
                skip: 0,
                limit: this._pageSize * 2,
            });
        }
    }

    _osResultsFeedReestablish() {
        return this.reestablish(this._activeOrgId, this._filter, this._entityFields, this._sort);
    }
}

module.exports = PagingOsPlanResultsFeed;
